import { cn } from '../../../shared/lib/cn';
import { Highlight } from '../../../shared/ui/highlight';
import { senderLine, senderMonogram, type TSender } from '../../../entities/auth-preset';

const ReadingTag = () => (
  <span className="inline-flex h-5 shrink-0 items-center rounded-tag bg-chip-on px-label text-micro text-muted">
    our reading is less sure
  </span>
);

interface ISenderRowProps {
  sender: TSender;
  query: string;
  withShape: boolean;
  selected: boolean;
  onSelect: () => void;
}

export const SenderRow = ({ sender, query, withShape, selected, onSelect }: ISenderRowProps) => (
  <button
    type="button"
    onClick={onSelect}
    aria-current={selected || undefined}
    className={cn(
      'flex h-row-2line w-full items-center gap-flat px-4 text-left',
      selected ? 'bg-highlight' : 'hover:bg-hover-raised',
    )}
  >
    <span
      aria-hidden
      className="flex size-avatar shrink-0 items-center justify-center rounded-control bg-chip-on text-micro font-semibold text-muted"
    >
      {senderMonogram(sender.name)}
    </span>

    <span className="min-w-0 flex-1">
      <span className="block truncate text-data text-primary">
        <Highlight text={sender.name} query={query} />
      </span>
      {sender.matchedOn === 'alias' ? (
        <span className="block truncate text-micro text-faint">
          matched a former name or a domain
        </span>
      ) : (
        <span className="block truncate font-mono text-micro text-faint">
          <Highlight text={senderLine(sender, withShape)} query={query} />
        </span>
      )}
    </span>

    {sender.confidence === 'medium' && <ReadingTag />}
  </button>
);
